import React, { ReactElement, ReactNode } from 'react';
import s from './CustomButton.module.scss';

interface ButtonProps {
  children?: ReactNode;
  onClick: () => void;
}

const CustomButton = (props: ButtonProps): ReactElement => {
  const { children, onClick } = props;
  return (
    <button className={s.wrapper} type="button" onClick={onClick}>
      <div className={s.button}>
        <span>{children}</span>
      </div>
    </button>
  );
};

CustomButton.defaultProps = {
  children: null,
};

export default CustomButton;
